module.exports = __webpack_public_path__ + "img/t6.68ac303e.png";